import React from 'react';

const AddEvent = () => {
    return (
        <div>
            add events
        </div>
    );
};

export default AddEvent;